import { render, staticRenderFns } from "./what-we-do.vue?vue&type=template&id=00485924&scoped=true&"
import script from "./what-we-do.vue?vue&type=script&lang=js&"
export * from "./what-we-do.vue?vue&type=script&lang=js&"
import style0 from "./what-we-do.vue?vue&type=style&index=0&id=00485924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00485924",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardActions,VCardText,VCol,VImg,VRow,VSheet})
